<template>
  <transition name="el-zoom-in-center">
    <div class="bg-contain common-blue-contain">
      <div class="breadcrumb-tilte">{{ $t('DataRecord') }} > {{ $t('BatteryPowerrecord') }}</div>
      <!-- 页面业务逻辑抽取至组件，新旧版界面共享，同时使用git摘取此提交同步至私有化 -->
      <Battery :userId="userId" />
    </div>
  </transition>
</template>
<script>
import Battery from '@/views/log/battery/Battery-componet.vue'
export default {
  // 实时监控》历史记录》组件弹窗传用户名
  props: {
    userId: {
      type: String,
    },
  },
  components: {
    Battery,
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
.bg-contain .common-table-cnt:has(.total-flow) /deep/ .el-table {
  height: 560px !important;
}
.bg-contain .search .pagination .el-input__inner{
  height 28px!important;
  line-height: 28px!important;
}
.common-blue-contain
  .el-pagination
    margin-top 18px
>>>.el-popper
 min-width 100%!important
</style>
